// extracted by mini-css-extract-plugin
export default {"root":"uKaZImajER2l52grupUV","fullWidth":"lU56K8Di9bbKuixQXkAQ"};